import { useState, useEffect } from 'react';

const STORAGE_KEY = 'user-favorite-clients';

export const useFavoriteClients = () => {
  const [favorites, setFavorites] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.error('Failed to save favorite clients:', error);
    }
  }, [favorites]);

  const toggleFavorite = (clientValue: string) => {
    setFavorites(prev =>
      prev.includes(clientValue)
        ? prev.filter(v => v !== clientValue)
        : [...prev, clientValue]
    );
  };

  const isFavorite = (clientValue: string) => favorites.includes(clientValue);

  return {
    favorites,
    toggleFavorite,
    isFavorite,
  };
};
